/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import DataConnector from 'connect/DataConnector';
import {Printer} from 'constants/SampleConstants';
import * as LabelPrintingActions from 'label-printing/LabelPrintingActions';
import * as RegistryUtil from 'registry/RegistryUtil';
import StorableStore from 'samples/StorableStore';
import EditableItemTable from 'ui-library/EditableItemTable';
import * as modals from 'util/Modals';

class PrintersListingConnector extends DataConnector<PrintersListingProps, EnhancedProps> {
  props: any;
  storableStore: any;
  stores = [StorableStore];

  enhanceProps(): EnhancedProps {
    return {printers: this.storableStore().getPrinters(this.props.registryId)};
  }
}

export interface PrintersListingProps {
  isWritable: boolean;
  ownerUrlId: string;
  registryId: string;
}
interface EnhancedProps {
  printers?: Array<Printer>;
}

class PrintersListing extends React.Component<PrintersListingProps & EnhancedProps> {
  componentDidMount(): void {
    LabelPrintingActions.fetchPrinters();
  }

  _getEditUrl = (index: any): string => {
    const printerId = this.props.printers![index].id;
    return RegistryUtil.getPrinterSettingsUrl(this.props.ownerUrlId, this.props.registryId, printerId);
  };

  _handleDelete = (index: any): void => {
    const printer = this.props.printers![index];
    modals.confirm(`Delete ${printer.name}`, 'Are you sure you want to delete this printer?').done(() => {
      LabelPrintingActions.deletePrinter(printer.id);
    });
  };

  render(): JSX.Element {
    let rows;
    if (this.props.printers) {
      rows = this.props.printers.map((printer, i) => ({
        itemIndex: i,
        values: [printer.name, printer.address, printer.port],
      }));
    }
    const columnHeaders = [
      {name: 'Name', width: 5},
      {name: 'Address', width: 4},
      {name: 'Port', width: 3},
    ];
    return (
      // @ts-expect-error ts-migrate(2741) FIXME: Property 'subheaderNode' is missing in type '{ col... Remove this comment to see the full error message
      <EditableItemTable
        columnHeaders={columnHeaders}
        emptyMessage="Please contact Benchling support before configuring printers."
        isLoading={!this.props.printers}
        onDelete={this._handleDelete}
        getEditUrl={this._getEditUrl}
        rows={rows}
        writable={this.props.isWritable}
      />
    );
  }
}

export default PrintersListingConnector.connect(PrintersListing);
